import React from 'react';

interface Props {
  size?: number;
  /** Kept for API compatibility — visual is now the same on light and dark BGs. */
  variant?: 'default' | 'mono-light';
  className?: string;
}

export function LogoMark({ size = 26, className = '' }: Props) {
  return (
    <img
      src="/logo-mark-transparent-192.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={className}
      style={{ display: 'inline-block', objectFit: 'contain' }}
      draggable={false}
    />
  );
}

interface WordmarkProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'on-light' | 'on-green';
  className?: string;
}

const WORD_SIZE: Record<NonNullable<WordmarkProps['size']>, string> = {
  sm: 'text-[15px]',
  md: 'text-[18px]',
  lg: 'text-[22px]',
};

export function Wordmark({ size = 'md', variant = 'on-light', className = '' }: WordmarkProps) {
  const baseColor = variant === 'on-green' ? 'text-white' : 'text-ink-900';
  return (
    <span
      className={[
        'font-display font-bold tracking-[-0.01em]',
        WORD_SIZE[size],
        baseColor,
        className,
      ].join(' ')}
    >
      Bora<span className="text-gold-500">Trocar</span>
    </span>
  );
}

interface FullLogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'on-light' | 'on-green';
  markSize?: number;
  className?: string;
}

export function Logo({ size = 'md', variant = 'on-light', markSize = 26, className = '' }: FullLogoProps) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={markSize} variant={variant === 'on-green' ? 'default' : 'default'} />
      <Wordmark size={size} variant={variant} />
    </span>
  );
}
